<script setup>
import { ref } from "vue";
import InlineSvg from "@/features/InlineSvg.vue";
import BaseText from "@/library/BaseText.vue";

defineProps({
  feature: {
    type: Object,
    required: true,
  },
});

const isExpanded = ref(false);
</script>

<template>
  <li
    class="choose-plan-feature-item"
    :class="{
      'choose-plan-feature-item--expanded': isExpanded,
    }"
    @click="isExpanded = !isExpanded"
  >
    <InlineSvg
      name="chevron-down"
      class="choose-plan-feature-item__expand"
    />
    <BaseText
      variant="body-2-semibold"
      class="choose-plan-feature-item__title"
    >
      {{ feature.title }}
    </BaseText>
    <InlineSvg
      name="checkmark-plain"
      class="choose-plan-feature-item__checkmark"
    />
    <BaseText
      variant="body-small-medium"
      class="choose-plan-feature-item__detail"
    >
      {{ feature.detail }}
    </BaseText>
  </li>
</template>

<style scoped lang="scss">
.choose-plan-feature-item {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  cursor: pointer;
  padding: 4px 0;

  &__title {
    @at-root .choose-plan-feature-item:hover & {
      opacity: 0.8;
    }
  }

  &__detail {
    display: none;

    @at-root .choose-plan-feature-item--expanded & {
      display: block;
      flex-shrink: 0;
      width: 100%;
      padding: 0 25px;
      opacity: 0.7;
    }
  }

  &__checkmark {
    margin-left: auto;
    color: $color-success;
  }

  &__expand {
    width: 18px;
    height: 18px;

    @at-root .choose-plan-feature-item--expanded & {
      transform: rotate(180deg);
    }
  }
}
</style>
